import { Layout, Dropdown, Menu, Space } from "antd";
import { GlobalOutlined } from "@ant-design/icons";
import { tenantsInfo as recoilTenantsInfo } from "@/recoil";
import { envConfig } from "@/envConfig";
import { useRecoilState, useRecoilValue } from "recoil";
import { switchLocale, i18n as i } from "@/i18n";
import { getAppUrl } from "@/utils/sso";
import styles from "./header.module.less";
import { useRef, useEffect, useState} from "react";
import { clearToken } from "@/utils/sessionToken";
import {
  getLocaleOptions,
  LocaleOption,
  PlatformType,
} from "@/gs-utils/core/storage/LocaleManager";
import { applicationPermissions as recoilApplicationPermissions } from "@/recoil";
import { getApplicationPermission } from "@/api/cedar";
import { HeaderApplicationGrid, filterPermissionApps, BASE_APP_CONFIGS_LIST } from "@/components/gs-web-ui";
import { PlatformAppType } from "@/components/gs-web-ui/AppGrid";
const { Header } = Layout;

interface GlobalHeaderType {}

function GlobalHeader(props: GlobalHeaderType) {
  const tenantsInfo = useRecoilValue(recoilTenantsInfo);
  const userRef = useRef(null);
  const [applicationPermissions, setApplicationPermissions] = useRecoilState(recoilApplicationPermissions);
  const handleLogout = () => {
    clearToken();
    window.location.href = `${envConfig.logout}?app=${encodeURIComponent(
      getAppUrl()
    )}`;
  };


  const getApplicationPermissionList = async (personId: string) => {
    const resp = await getApplicationPermission({
      personId: tenantsInfo?.person?.id,
    });
    setApplicationPermissions(resp.data);
  };

  useEffect(() => {
    if (tenantsInfo?.person?.id) {
      getApplicationPermissionList(tenantsInfo?.person?.id);
    }
  }, [tenantsInfo?.person?.id]);

  const onVisibleChange = (visible: boolean, el: any) => {
    if (!el.current || !el.current.classList) return;
    console.log("GlobalHeader | onVisibleChange", { visible, el });
    if (visible) el.current.classList.add(styles.active);
    else el.current.classList.remove(styles.active);
  };

  const changeLanguage = (item: LocaleOption) => {
    switchLocale(item?.value);
  };

  const languageEle = (
    <Menu className={styles.menu}>
      {getLocaleOptions(PlatformType.ALL).map((item) => {
        return (
          <Menu.Item className={styles.menuItem} key={item.value}>
            <span onClick={() => changeLanguage(item)}>{item.label}</span>
          </Menu.Item>
        );
      })}
    </Menu>
  );

  const menu = (
    <Menu className={styles.menu}>
      <Menu.Item key="logout" className={styles.menuItem}>
        <span onClick={handleLogout}>{i("登出")}</span>
      </Menu.Item>
    </Menu>
  );
  return (
    <Header className={styles.header}>
      <HeaderApplicationGrid
        availableApps={filterPermissionApps(BASE_APP_CONFIGS_LIST, { applicationPermissionList: applicationPermissions, internalPerson: tenantsInfo?.internalPerson })}
        currentAppKey={PlatformAppType.APPLICATION_CENTER}
      />
      <div className={styles.rightMenu}>
        <Space>
          <Dropdown
            overlay={menu}
            onVisibleChange={(e) => onVisibleChange(e, userRef)}
          >
            <span className={styles.action} ref={userRef}>
              {tenantsInfo?.person
                ? tenantsInfo?.person?.username
                : i("未登录")}
            </span>
          </Dropdown>
        </Space>
      </div>
    </Header>
  );
}

export default GlobalHeader;
